var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetodologyStep7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1805_8792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 97,
    height: 97
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.3125 95.0605V1.06055H1.06641V95.0605H95.3125Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1805_8792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6802 83.8577C20.4422 82.1003 20.4422 79.251 18.6802 77.4938C16.9183 75.7363 14.0617 75.7363 12.3 77.4938C10.538 79.251 10.538 82.1003 12.3 83.8577C14.0617 85.6151 16.9183 85.6151 18.6802 83.8577Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0767 18.6272C85.8387 16.8698 85.8387 14.0205 84.0767 12.2633C82.3148 10.5059 79.4582 10.5059 77.6965 12.2633C75.9345 14.0205 75.9345 16.8698 77.6965 18.6272C79.4582 20.3847 82.3148 20.3847 84.0767 18.6272Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5326 38.9672C94.1219 41.907 94.4311 44.9479 94.4311 48.0605C94.4311 73.5347 73.7273 94.1855 48.1878 94.1855C37.0389 94.1855 26.812 90.2497 18.8262 83.6957",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1152 30.8767C91.1168 30.8807 91.1185 30.8848 91.1201 30.8887",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.84668 57.168C2.25548 54.2237 1.94531 51.1783 1.94531 48.0605C1.94531 22.5862 22.6491 1.93553 48.1886 1.93553C59.3375 1.93553 69.5644 5.87134 77.5502 12.4254",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.29348 65.3262C5.28289 65.2999 5.27231 65.2736 5.26172 65.2473",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1889 63.8106C39.4681 63.8106 32.3986 56.7591 32.3986 48.0606C32.3986 39.3621 39.4681 32.3106 48.1889 32.3106C56.9097 32.3106 63.9793 39.3621 63.9793 48.0606C63.9793 56.7591 56.9097 63.8106 48.1889 63.8106ZM75.8636 42.085C75.1356 38.7055 73.8024 35.5504 71.9809 32.7389L75.642 29.0871L67.1908 20.6637L63.5327 24.3124C60.7139 22.4955 57.5509 21.1658 54.1628 20.4398V15.2794H42.2151V20.4398C38.8269 21.1658 35.664 22.4955 32.8452 24.3124L29.1871 20.6637L20.7358 29.0871L24.397 32.7389C22.5754 35.5504 21.2423 38.7055 20.5142 42.085H15.3269L15.3203 54.0019H20.5142C21.2421 57.3814 22.5752 60.5367 24.3968 63.3482L20.7218 67.0139L29.1668 75.4435L32.8448 71.7749C35.6636 73.5917 38.8269 74.9215 42.2151 75.6477V80.8418H54.1628V75.6477C57.5509 74.9215 60.7143 73.5917 63.5331 71.7749L67.2111 75.4435L75.6561 67.0139L71.9811 63.3482C73.8026 60.5367 75.1358 57.3814 75.8636 54.0019H81.0576V42.085H75.8636Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1385 49.4449L46.7432 54.1729C45.646 54.8744 44.2051 54.0885 44.2051 52.7886V43.3326C44.2051 42.0327 45.646 41.2467 46.7432 41.9483L54.1385 46.6763C55.1504 47.3232 55.1504 48.798 54.1385 49.4449Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetodologyStep7);
export default __webpack_public_path__ + "static/media/metodology-step7.8c7b6f0278d4de6b360a0c549dc99a95.svg";
export { ForwardRef as ReactComponent };